mutation PracticeHeartbeat($aliyahId: Int, $haftarahId: Int, $sentenceGroupId: Int) {
  practiceHeartbeat(aliyahId: $aliyahId, haftarahId: $haftarahId, sentenceGroupId: $sentenceGroupId) {
    ok
    errors
    activityId
  }
}
